module.exports = __webpack_public_path__ + "img/keFu.d8d7424c.png";